import axios from 'axios';
import { API_URL } from '../consts';

const fetchPermissions = async () => {
  const res = await axios.get(`${API_URL}/permissions`);
  return res.data;
};

export default fetchPermissions;
